module.exports = __webpack_public_path__ + "static/media/dropdown.1cb0c46a.svg";